import(/* webpackMode: "eager" */ "/home/ubuntu/download/697c0d60921dc900144a1c6b/mindshift_ai/src/app/not-found.tsx");
